// theme.config.js
export default {
  nextLinks: false,
  prevLinks: false,
  search: false,
  customSearch: null, // customizable, you can use algolia for example
  darkMode: false,
  footer: false,
  header: false,
  logo: <></>,
  head: (
    <>
      <title>NFT.Storage Docs</title>
    </>
  ),
}
